module.exports = __webpack_public_path__ + "static/media/magic-flakes.17913c68.png";